import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la falta de protección",
    opening: localizedGenderNode(
      [
      "Hoy no intento arreglarlo.",
      "Solo noto la falta de protección.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento arreglarlo.",
      "Solo noto la falta de protección.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se siente más la falta de protección?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo se siente más la falta de protección?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar ya es el comienzo de una protección interna."
    ],
      [
      "Notar ya es el comienzo de una protección interna."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que necesitaba",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que necesitaba entonces.",
      "Sin culpa.",
      "Solo ver."
    ],
      [
      "Hoy noto lo que necesitaba entonces.",
      "Sin culpa.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesitaba escuchar entonces?",
      "¿Qué necesitaba que pasara?",
      "¿Qué todavía me falta hoy?"
    ],
      [
      "¿Qué necesitaba escuchar entonces?",
      "¿Qué necesitaba que pasara?",
      "¿Qué todavía me falta hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar la necesidad ya es suavidad."
    ],
      [
      "Notar la necesidad ya es suavidad."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre la necesidad.",
      "escribir una palabra sobre la necesidad."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Cómo se quedó en mí",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que se quedó en mí desde entonces.",
      "Sin juicio.",
      "Solo verdad."
    ],
      [
      "Hoy noto lo que se quedó en mí desde entonces.",
      "Sin juicio.",
      "Solo verdad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde me encuentra hoy?",
      "¿Qué intento evitar sentir?",
      "¿Cómo afecta a las relaciones?"
    ],
      [
      "¿Dónde me encuentra hoy?",
      "¿Qué intento evitar sentir?",
      "¿Cómo afecta a las relaciones?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo que se quedó en mí pide suavidad."
    ],
      [
      "Lo que se quedó en mí pide suavidad."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La parte que se siente desprotegida",
    opening: localizedGenderNode(
      [
      "Hoy noto la parte en mí que se siente desprotegida.",
      "No para arreglarla.",
      "Solo estar con ella."
    ],
      [
      "Hoy noto la parte en mí que se siente desprotegida.",
      "No para arreglarla.",
      "Solo estar con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ],
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar con él un momento ya es un cambio pequeño."
    ],
      [
      "Estar con él un momento ya es un cambio pequeño."
    ]
    ),
    action: localizedGenderNode(
      "poner una mano en el corazón y respirar.",
      "poner una mano en el corazón y respirar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo a que no haya nadie",
    opening: localizedGenderNode(
      [
      "Hoy noto el miedo a que no haya nadie.",
      "No para pelear.",
      "Solo ver."
    ],
      [
      "Hoy noto el miedo a que no haya nadie.",
      "No para pelear.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué tengo miedo aquí?",
      "¿Qué creo que pasará si pido?",
      "¿Cómo me protege este miedo?"
    ],
      [
      "¿De qué tengo miedo aquí?",
      "¿Qué creo que pasará si pido?",
      "¿Cómo me protege este miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo pide protección."
    ],
      [
      "El miedo pide protección."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Una petición pequeña de protección",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña de protección.",
      "No grande.",
      "Pequeña."
    ],
      [
      "Hoy formulo una petición pequeña de protección.",
      "No grande.",
      "Pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me da una pequeña sensación de protección?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué me da una pequeña sensación de protección?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede calmarme."
    ],
      [
      "Una petición puede calmarme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un pequeño momento de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy busco un pequeño momento de seguridad.",
      "No mucho.",
      "Solo un poco."
    ],
      [
      "Hoy busco un pequeño momento de seguridad.",
      "No mucho.",
      "Solo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo sentí una pequeña seguridad recientemente?",
      "¿Qué permitió que ocurriera?",
      "¿Qué podría invitar otro momento así?"
    ],
      [
      "¿Cuándo sentí una pequeña seguridad recientemente?",
      "¿Qué permitió que ocurriera?",
      "¿Qué podría invitar otro momento así?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento pequeño cambia el rumbo."
    ],
      [
      "Un momento pequeño cambia el rumbo."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un límite que me protege",
    opening: localizedGenderNode(
      [
      "Hoy observo un límite pequeño que me protege.",
      "No para alejarme.",
      "Solo proteger."
    ],
      [
      "Hoy observo un límite pequeño que me protege.",
      "No para alejarme.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento los hombros."
    ],
      [
      "Respiro despacio.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ],
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño protege el corazón."
    ],
      [
      "Un límite pequeño protege el corazón."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Quedarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme conmigo cuando sube la falta de protección.",
      "No huir.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme conmigo cuando sube la falta de protección.",
      "No huir.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ],
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es un pequeño ancla."
    ],
      [
      "Quedarme conmigo es un pequeño ancla."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cada vez que suba la sensación.",
      "una respiración cada vez que suba la sensación."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición clara",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición clara para mí.",
      "No grande.",
      "Clara."
    ],
      [
      "Hoy formulo una petición clara para mí.",
      "No grande.",
      "Clara."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito ahora para sentirme protegido/a?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué necesito ahora para sentirme protegido/a?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición clara puede calmarme."
    ],
      [
      "Una petición clara puede calmarme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor que me sostiene",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor que me sostiene.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor que me sostiene.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor me importa dentro de un vínculo?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor me importa dentro de un vínculo?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor es un hilo de estabilidad."
    ],
      [
      "Un valor es un hilo de estabilidad."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Escuchar mi necesidad",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi necesidad.",
      "No para apartarla.",
      "Solo escucharla."
    ],
      [
      "Hoy escucho mi necesidad.",
      "No para apartarla.",
      "Solo escucharla."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ],
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es la necesidad más viva en mí ahora?",
      "¿Cómo suena en palabras simples?",
      "¿Qué podría darle un pequeño lugar?"
    ],
      [
      "¿Cuál es la necesidad más viva en mí ahora?",
      "¿Cómo suena en palabras simples?",
      "¿Qué podría darle un pequeño lugar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Escuchar la necesidad ya es un cambio."
    ],
      [
      "Escuchar la necesidad ya es un cambio."
    ]
    ),
    action: localizedGenderNode(
      "escribir la necesidad en una palabra.",
      "escribir la necesidad en una palabra."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de seguridad.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de seguridad.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para acercarme."
    ],
      [
      "Un paso pequeño es suficiente para acercarme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la protección interna.",
      "Cuando me asusto.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la protección interna.",
      "Cuando me asusto.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta falta de protección?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre esta falta de protección?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo sentirme desprotegido/a y aun así quedarme conmigo."
    ],
      [
      "Puedo sentirme desprotegido/a y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const lackOfProtectionChildhoodWereNotThereForMeBlueprintEs = buildNormalizedPilotBlueprint({
  id: "lack_of_protection_childhood_were_not_there_for_me_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "lack_of_protection_childhood_were_not_there_for_me",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "חוסר הגנה בילדות (לא היו שם בשבילי)",
    en: "Lack of protection in childhood (they were not there for me)",
    es: "Falta de protección en la infancia (no estuvieron para mí)",
  },
  days,
});

export default lackOfProtectionChildhoodWereNotThereForMeBlueprintEs;
